module.exports = __webpack_public_path__ + "img/info_bg1.3cba32ad.png";